import {
  LOAD_ACCOUNT_CREDIT_REQUEST,
  LOAD_ACCOUNT_CREDIT_SUCCESS,
  LOAD_ACCOUNT_CREDIT_ERROR,
} from "../actions/types";
import initialState from "../store/initial-state";

// eslint-disable-next-line default-param-last
const accountCredit = (state = initialState.accountCredit, action) => {
  switch (action.type) {
    case LOAD_ACCOUNT_CREDIT_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
      };
    case LOAD_ACCOUNT_CREDIT_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case LOAD_ACCOUNT_CREDIT_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default accountCredit;
